import { useParams } from 'react-router-dom';
import React, { useState } from 'react';
import { convertDateFromServer } from 'app/shared/util/date-utils';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import ViewTable from 'app/shared/view-table/view-table';
import ViewTableHeaderColumn from 'app/shared/view-table/view-table-header-column';
import { LocationPermitComplianceAddFormModel } from 'app/edozvola/cases/location-permit-compliance/model/location-permit-compliance.model';
import { fetchLocationPermitCompliancePageQuery } from 'app/edozvola/cases/location-permit-compliance/service/location-permit-compliance.queries';
import LocationPermitComplianceDeleteModal from 'app/edozvola/cases/location-permit-compliance/location-permit-compliance-delete-modal';
import { TABLE_QUERY_KEYS } from 'app/config/constants';
import { getInvalidRowsForTable } from 'app/shared/util/validation-errors.util';
import { getCaseContext } from 'app/shared/util/context-util';
import { TooltipWrapper } from 'edozvola-frontend-lib/dist/ui/components/tooltipwrapper';

export interface ILocationPermitComplianceTableProps {
  onRowClick: (webId: string) => void;
  editLocationPermitComplianceDisabled: boolean;
}

const LocationPermitComplianceTable = (props: ILocationPermitComplianceTableProps) => {
  const { id } = useParams<{ id: string }>();
  const [modalOpened, setModalOpened] = useState(false);
  const [idToDelete, setIdToDelete] = useState('');
  const { sidebarItemPair } = getCaseContext();

  const invalidRowIds = getInvalidRowsForTable(TABLE_QUERY_KEYS.LOCATION_PERMIT_COMPLIANCE_TABLE);

  const deleteLocationPermit = (webId: string) => {
    setIdToDelete(webId);
    setModalOpened(true);
  };

  const cancelDeletion = () => {
    setIdToDelete('');
    setModalOpened(false);
  };

  const renderRow = (value: LocationPermitComplianceAddFormModel, caseIndex: number) => {
    return (
      <tr key={caseIndex} className={invalidRowIds.includes(value.idCaseLocationPermitComplianceMap) ? 'hand invalid-table-row' : 'hand'}>
        <td>
          <div className={'column-with-multiple-data'}>
            <span>{value.webId}</span>
            <span>{value.finalActDocumentName}</span>
          </div>
        </td>
        <td>
          <div className={'column-with-multiple-data'}>
            <span>{value.classification}</span>
            <span>{value.finalActFileNumber}</span>
          </div>
        </td>
        <td>{convertDateFromServer(value.finalDocumentAdmissionDate)}</td>
        <td>{convertDateFromServer(value.executionDate)}</td>
        <td>{convertDateFromServer(value.effectivenessDate)}</td>

        <td>
          <div className={'actions-container'}>
            {sidebarItemPair?.canView && (
              <TooltipWrapper message={'Pregledaj'}>
                <FontAwesomeIcon
                  icon={'eye'}
                  className={'icon-table'}
                  onClick={() => props.onRowClick(value.idCaseLocationPermitComplianceMap)}
                />
              </TooltipWrapper>
            )}
            {sidebarItemPair?.canDelete && props.editLocationPermitComplianceDisabled === false && (
              <TooltipWrapper message={'Obriši'}>
                <FontAwesomeIcon
                  icon={'trash'}
                  className={'icon-table'}
                  onClick={() => deleteLocationPermit(value.idCaseLocationPermitComplianceMap)}
                />
              </TooltipWrapper>
            )}
          </div>
        </td>
      </tr>
    );
  };

  return (
    <>
      <ViewTable
        initialPaginationColumn={'webId'}
        renderTableRow={renderRow}
        fetchDataQuery={fetchLocationPermitCompliancePageQuery}
        fetchDataProps={id}
        noDataMessage={'Nema dodanih akata.'}
      >
        <ViewTableHeaderColumn renderSort sortKey={'webId'} columnLabels={['Šifra predmeta', 'Naziv akta']} />
        <ViewTableHeaderColumn renderSort sortKey={'classification'} columnLabels={['Klasifikacijska oznaka', 'Urudžbeni broj']} />
        <ViewTableHeaderColumn renderSort sortKey={'solutionDate'} columnLabels={['Datum rješavanja']} />
        <ViewTableHeaderColumn renderSort sortKey={'executionDate'} columnLabels={['Datum izvršnosti']} />
        <ViewTableHeaderColumn renderSort sortKey={'effectivenessDate'} columnLabels={['Datum pravomoćnosti']} />
        <ViewTableHeaderColumn renderSort={false} columnLabels={['Akcije']} width={'75px'} />
      </ViewTable>
      <LocationPermitComplianceDeleteModal
        isModalOpen={modalOpened}
        closeModalCallback={cancelDeletion}
        idLocationPermitComplianceMap={idToDelete}
      />
    </>
  );
};

export default LocationPermitComplianceTable;
